import React from 'react';
import { styles } from './TabsBlock.css';
import { ListingBlock, ListingBlockProps } from '../ListingBlock';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';
import { CarouselTabs } from '../CarouselTabs/CarouselTabs';
import { MinimalTab } from '../CarouselTabs/MinimalTab/MinimalTab';

export type TabsBlockProps = Omit<ListingBlockProps, 'children'> & {
  palette: ContentThemePalette;
  tabs: Array<{ label: string; contents: React.ReactElement }>;
};

export const TabsBlock = ({ tabs, palette, testId, heading, subHeading, ...listingBlockProps }: TabsBlockProps) => {
  return (
    <ListingBlock
      {...listingBlockProps}
      testId={testId}
      palette={palette}
      heading={
        <div className={styles.headingContainer} style={{ color: palette.heading ?? palette.text }}>
          {heading}
        </div>
      }
      subHeading={
        subHeading ? (
          <div
            className={styles.subHeadingContainer}
            style={{ color: palette.text ?? palette.heading }}
            data-testid={`${testId}-subheading`}
          >
            {subHeading}
          </div>
        ) : undefined
      }
    >
      <CarouselTabs
        testId={testId}
        textColor={palette.heading ?? palette.text}
        tabs={tabs.map(tab => ({
          renderLabel: props => <MinimalTab {...props} label={tab.label} />,
          contents: tab.contents,
        }))}
      />
    </ListingBlock>
  );
};
